module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/router-153.vue");


//////////////////
// WEBPACK FOOTER
// ./en/development/router.md
// module id = 571
// module chunks = 405